import React from "react";
import Select, { SelectProps } from "@amzn/awsui-components-console/select";
import { useAuth, GroupView } from "./Authentication";
import { isAdminUser } from "../utils/AuthUtils";

const GroupViewSwitcher: React.FC = () => {
  const { user, switchGroupView } = useAuth();

  if (!user || !isAdminUser(user.originalUser || user)) {
    return null;
  }

  const groupOptions: SelectProps.Option[] = [
    { label: "Admin View", value: "admin" },
    { label: "Partner Admin View", value: "partner admin" },
    { label: "Builder View", value: "builder" },
    { label: "Tester View", value: "tester" },
    { label: "Sales View", value: "sales" },
    { label: "Partner View", value: "partner" },
  ];

  const currentView = user.currentGroupView || "admin";

  return (
    <div style={{ minWidth: "200px" }}>
      <Select
        selectedOption={
          groupOptions.find((option) => option.value === currentView) ||
          groupOptions[0]
        }
        onChange={({ detail }) =>
          switchGroupView(detail.selectedOption.value as GroupView)
        }
        options={groupOptions}
        placeholder="Select group view"
        ariaLabel="Switch between different group views"
      />
    </div>
  );
};

export default GroupViewSwitcher;
